import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  lazyComponent: true,
  loading: '/no-image.png',
  error: '/no-image.png',
  throttleWait: 0
})
